import {
  Datagrid,
  TextField,
  ShowButton,
  EditButton,
  ReferenceField,
} from "react-admin";
import { ColorField } from "react-admin-color-picker";
import {
  DateField,
  DeleteButton,
  CreateOnlyTopToolbar,
  CustomList,
} from "../../shared/components/index.js";

const listPage = () => (
  <CustomList actions={<CreateOnlyTopToolbar />}>
    <Datagrid rowClick={false} bulkActionButtons={false}>
      <TextField source="name" />
      <ReferenceField source="design_id" reference="Design" link="show">
        <TextField source="name" />
      </ReferenceField>
      <ColorField source="styles.color" sortable={false} />
      <ColorField source="styles.backgroundColor" sortable={false} />
      <DateField source="created_at" />
      <DateField source="updated_at" />
      <ShowButton className="button-show" />
      <EditButton className="button-edit" />
      <DeleteButton />
    </Datagrid>
  </CustomList>
);

export default listPage;
